import React from "react";

const ArjeeActiveSkeleton = ({ showUpcomingSlot = true, showProof = true }) => {
  return (
    <div className="flex flex-col justify-center items-center mb-8 w-full">
      <div className="w-full max-w-[30.5rem] animate-pulse">
        {/* 1. Status Pill */}
        <div className="w-full px-5 sm:px-7 my-5">
          <div className="w-full h-10 bg-purple-50/90 rounded-full flex items-center justify-center border border-purple-100/60 shadow-sm px-4">
            <div className="h-4 w-44 bg-purple-200/70 rounded-full" />
          </div>
        </div>

        {/* 2. Arjee Overview Card */}
        <div className="w-full px-5 sm:px-7 mb-5">
          <div className="flex justify-between items-center rounded-2xl gap-4 bg-white">
            <div className="w-[5rem] h-[5.5rem] rounded-md bg-gray-200 shrink-0" />

            <div className="flex flex-1 flex-col justify-between items-start gap-1.5 min-w-0">
              <div className="flex justify-between items-center w-full">
                <div className="h-5 w-28 bg-gray-200 rounded-md" />
                <div className="h-5 w-14 bg-green-100 rounded-md" />
              </div>
              <div className="h-2.5 w-full bg-gray-100 rounded mt-1" />
              <div className="h-2.5 w-4/5 bg-gray-100 rounded" />
              <div className="h-4 w-32 bg-orange-50 rounded-full mt-1" />
            </div>
          </div>
        </div>

        {/* Upcoming Slot Pill */}
        {showUpcomingSlot && (
          <div className="mx-7 my-5 h-10 bg-purple-50/90 rounded-full flex items-center justify-center border border-purple-100/60 shadow-sm px-4">
            <div className="h-4 w-48 bg-purple-200/70 rounded-full" />
          </div>
        )}

        {/* WhatsApp Channel Line */}
        <div className="mx-7 mb-4 flex items-center gap-2">
          <div className="w-4 h-4 rounded-full bg-gray-200 shrink-0" />
          <div className="h-3.5 w-3/4 bg-gray-100 rounded" />
        </div>

        {/* Action Buttons Row */}
        <div className="m-7 flex gap-4 justify-between">
          <div className="h-10 flex-1 bg-gray-100 rounded-xl" />
          <div className="h-10 flex-1 bg-gray-100 rounded-xl" />
        </div>

        {/* Arjee & Devotee Details Card */}
        <div className="mx-7 my-5 border border-[#CCC2C9]/70 rounded-xl p-4 bg-white shadow-sm flex flex-col gap-4">
          <div className="flex justify-between items-center pb-3 border-b border-gray-100">
            <div className="h-4 w-32 bg-gray-200 rounded" />
            <div className="h-5 w-20 bg-orange-100 rounded-full" />
          </div>

          {/* Devotee Info Rows */}
          <div className="flex flex-col gap-2.5">
            <div className="flex justify-between items-center">
              <div className="h-3 w-20 bg-gray-100 rounded" />
              <div className="h-4 w-32 bg-gray-200 rounded" />
            </div>
            <div className="flex justify-between items-center">
              <div className="h-3 w-16 bg-gray-100 rounded" />
              <div className="h-4 w-24 bg-gray-200 rounded" />
            </div>
          </div>

          {/* Sankalp / Message Box */}
          <div className="w-full h-16 bg-gray-50 border border-gray-100 rounded-lg p-3 flex flex-col gap-2">
            <div className="h-3 w-5/6 bg-gray-200/80 rounded" />
            <div className="h-3 w-2/3 bg-gray-200/50 rounded" />
          </div>
        </div>

        {/* Proof / Video Placeholder Card */}
        {showProof && (
          <div className="mx-7 my-5 border border-[#CCC2C9]/70 rounded-xl p-4 bg-white shadow-sm flex flex-col gap-3">
            <div className="flex justify-between items-center">
              <div className="h-4 w-28 bg-gray-200 rounded" />
              <div className="h-4 w-16 bg-gray-100 rounded" />
            </div>
            <div className="w-full h-40 bg-gradient-to-br from-gray-100 via-gray-50 to-gray-100 rounded-xl border border-gray-100 flex items-center justify-center">
              <div className="w-10 h-10 rounded-full bg-gray-200/70" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArjeeActiveSkeleton;
